"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(theme) {
  return {
    content: {
      width: 384,
      padding: [[0, 30]],
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'column',
      overflow: 'auto'
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontSize: 13,
      padding: [[13, 30]],
      position: 'relative'
    },
    footer: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: 15,
      '& button': {
        height: 56
      },
      '& > *': {
        margin: [[0, 7.5]]
      },
      '& > *:first-child': {
        marginLeft: 0
      },
      '& > *:last-child': {
        marginRight: 0
      }
    },
    title: {
      paddingTop: '3px'
    },
    lightHeader: {
      color: theme.palette.secondary.main,
      backgroundColor: theme.palette.common.white,
      '& button': {
        color: theme.palette.primary.icon
      }
    },
    darkHeader: {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.common.white,
      '& button': {
        color: theme.palette.primary.icon
      }
    },
    actionIcon: {
      padding: 0,
      '& span': {
        width: 32,
        height: 32
      }
    }
  };
};

exports.default = _default;